<div class="column-layout-container" basepage="primary">
  <div class="menu animate-in-from-left" [class.mobile-shown]="appService.mobileMenuShown">
    <aside role="region" aria-label="side navigation">
      <div class="menu-top d-flex justify-content-between align-items-center">
        <fui-heading [text]="'orders.orders_title' | translate" [level]="5"></fui-heading>
        <div>
          <!-- <button class="fa-button m-r-10" placement="bottom" [ngbTooltip]="(refreshing ? 'general.refreshing_dots' : 'general.refresh') | translate" (click)="refresh()">
          <fa-icon icon="sync" class="action refresh circle-icon-btn" [animation]="refreshing ? 'spin' : undefined"></fa-icon>
        </button> -->
        </div>
      </div>

      <ul class="menu-options">
        <li class="menu-option" [class.active]="displayedSection == 'orders'">
          <a
            class="primary-option"
            tabindex="0"
            href="javascript:void(0);"
            (keyup.enter)="appService.mobileMenuShown = false; switchSection('orders')"
            (keyup.space)="appService.mobileMenuShown = false; switchSection('orders')"
            (click)="appService.mobileMenuShown = false; switchSection('orders')"
          >
            {{ "orders.my_orders" | translate }}
          </a>
        </li>
        <li class="menu-option" [class.active]="displayedSection == 'addresses'">
          <a
            class="primary-option"
            tabindex="0"
            href="javascript:void(0);"
            (keyup.enter)="appService.mobileMenuShown = false; switchSection('addresses')"
            (keyup.space)="appService.mobileMenuShown = false; switchSection('addresses')"
            (click)="appService.mobileMenuShown = false; switchSection('addresses')"
          >
            {{ "orders.address_book" | translate }}
          </a>
        </li>
        <li class="menu-option" [class.active]="displayedSection == 'gift_cards'">
          <a
            class="primary-option"
            tabindex="0"
            href="javascript:void(0);"
            (keyup.enter)="appService.mobileMenuShown = false; switchSection('gift_cards')"
            (keyup.space)="appService.mobileMenuShown = false; switchSection('gift_cards')"
            (click)="appService.mobileMenuShown = false; switchSection('gift_cards')"
          >
            {{ "orders.gift_cards" | translate }}
          </a>
        </li>
      </ul>
    </aside>
  </div>
  <section class="content animate-in-from-right" [class.mobile-shown]="!appService.mobileMenuShown">
    <button class="mobile-back-btn no-border" (click)="appService.mobileMenuShown = true">
      <fa-icon icon="chevron-left" aria-hidden="true"></fa-icon>
      {{ "orders.orders_options" | translate }}
    </button>
    @if (displayedSection == "orders") {
      <div class="container">
        <fui-heading [text]="'orders.my_orders' | translate" [level]="5"></fui-heading>
        <br />
        @if (!loading && !orders?.length && !fenderOrders?.length) {
          <div class="m-y-20 text-muted">{{ "orders.no_orders_to_display" | translate }}</div>
        }
        @if (!loading && orders?.length) {
          <myp-user-order-list [orders]="orders"></myp-user-order-list>
        }
        @if (!loading && fenderOrders?.length) {
          @for (order of fenderOrders; track order) {
            <myp-list-item
              [item]="orderService"
              [includeChevron]="false"
              [showImage]="true"
              [title]="order.description"
              [photo]="order.lineItems[0].image.src"
              [imageRound]="false"
              [collapsible]="true"
              [showBackground]="true"
              [metadata]="orderMetadata[order.id]"
              marginBottom="10px"
            >
              <div class="collapsible-content">
                <div class="row">
                  <div class="col-12">
                    <fui-heading [text]="'orders.in_this_order' | translate" [level]="6"></fui-heading>
                    <br />
                    @for (item of order.lineItems; track item) {
                      <div class="m-y-10">
                        <div class="d-flex align-items-start">
                          <img [src]="item.image.src" [alt]="item.title" class="m-r-10" style="width: 50px" />
                          <div class="flex-grow-1">
                            <div class="bold">{{ item.title }}</div>
                            <div class="text-muted">{{ item.variantTitle }}</div>
                            <div class="text-muted">{{ "orders.sku_label" | translate }}{{ item.sku }}</div>
                            <div class="m-t-10">
                              <div>{{ "orders.quantity_label" | translate }}{{ item.quantity }}</div>
                              @if (item.originalTotal.amount !== item.discountedTotal.amount) {
                                <div>
                                  <span class="text-muted" style="text-decoration: line-through">{{ item.originalTotal.amount }} {{ item.originalTotal.currency }}</span>
                                  <span class="bold m-l-10">{{ item.discountedTotal.amount }} {{ item.discountedTotal.currency }}</span>
                                </div>
                              }
                              @if (item.originalTotal.amount === item.discountedTotal.amount) {
                                <div>
                                  <span class="bold">{{ item.discountedTotal.amount }} {{ item.discountedTotal.currency }}</span>
                                </div>
                              }
                              @if (item.taxLines?.length) {
                                <div class="m-t-5">
                                  @for (tax of item.taxLines; track tax) {
                                    <div class="text-muted">{{ tax.title }}: {{ tax.priceSet.amount }} {{ tax.priceSet.currency }} ({{ tax.rate * 100 }}%)</div>
                                  }
                                </div>
                              }
                            </div>
                          </div>
                        </div>
                        <hr />
                      </div>
                    }
                    <div class="d-flex justify-content-end m-b-30">
                      <fui-heading [text]="('orders.order_total' | translate) + ' ' + order.totalPrice.amount + ' ' + order.totalPrice.currency" [level]="6"></fui-heading>
                    </div>
                    <fui-heading [text]="'orders.shipments' | translate" [level]="6"></fui-heading>
                    <br />
                    @for (fulfillment of order.fulfillments; track fulfillment) {
                      <div class="m-b-20">
                        <div class="bold">{{ fulfillment.name }}</div>
                        <div class="m-t-5">
                          <div>
                            {{ "orders.status_label" | translate }}
                            <span class="bold">{{ fulfillment.displayStatus }}</span>
                          </div>
                          @if (fulfillment.createdAt) {
                            <div>{{ "orders.created_label" | translate }}{{ fulfillment.createdAt | date }}</div>
                          }
                          @if (fulfillment.inTransitAt) {
                            <div>{{ "orders.in_transit" | translate }}{{ fulfillment.inTransitAt | date }}</div>
                          }
                          @if (fulfillment.estimatedDeliveryAt) {
                            <div>{{ "orders.estimated_delivery" | translate }}{{ fulfillment.estimatedDeliveryAt | date }}</div>
                          }
                          @if (fulfillment.deliveredAt) {
                            <div>{{ "orders.delivered" | translate }}{{ fulfillment.deliveredAt | date }}</div>
                          }
                          @if (fulfillment.updatedAt) {
                            <div>{{ "orders.last_updated" | translate }}{{ fulfillment.updatedAt | date }}</div>
                          }
                        </div>
                        @for (tracking of fulfillment.trackingInfo; track tracking) {
                          <div class="m-t-10">
                            <div class="bold">
                              {{ tracking.company }} {{ "orders.tracking" | translate }}
                              <a href="{{ tracking.url }}" target="_blank" class="bold">{{ tracking.number }}</a>
                            </div>
                          </div>
                        }
                      </div>
                      @if (order.fulfillments.length > 1) {
                        <hr />
                      }
                    }
                  </div>
                </div>
              </div>
            </myp-list-item>
          }
        }
        @if (loading) {
          <myp-inline-loader [loading]="true" height="200px" spinnerName="loader"></myp-inline-loader>
        }
      </div>
    }

    @if (displayedSection == "addresses") {
      <div class="container m-b-100">
        <fui-heading [text]="'orders.address_book' | translate" [level]="5"></fui-heading>
        <br />
        @if (!loading && !addresses?.length) {
          <div class="m-y-20 text-muted">{{ "orders.no_addresses_to_display" | translate }}</div>
        }
        @for (address of addresses; track address) {
          <myp-list-item
            [title]="address.name + ' ' + address.address1 + ' ' + address.formattedArea"
            [metadata]="address.metadata"
            [showImage]="false"
            [includeChevron]="false"
          >
            <div class="button-content">
              <fa-icon icon="pencil" class="action circle-icon-btn" [ngbTooltip]="'orders.edit_address' | translate" tabindex="0" (keyup.enter)="editAddress(address)" (click)="editAddress(address)"></fa-icon>
              <fa-icon icon="times" class="action circle-icon-btn" [ngbTooltip]="'orders.delete_address' | translate" tabindex="0" (keyup.enter)="deleteAddress(address)" (click)="deleteAddress(address)"></fa-icon>
              @if (editingAddresses[address.id]) {
                <fa-icon icon="spinner" animation="spin" class="action circle-icon-btn"></fa-icon>
              }
            </div>
          </myp-list-item>
        }
        <hr class="m-y-50" />
        <a class="btn btn-primary" (click)="addAddress()">{{ "orders.add_address" | translate }}</a>
      </div>
    }

    @if (displayedSection == "gift_cards") {
      <div class="container m-b-100">
        <fui-heading [text]="'orders.gift_cards' | translate" [level]="5"></fui-heading>
        <br />
        @if (!loading && !giftCards?.length) {
          <div class="m-y-20 text-muted">{{ "orders.no_gift_cards_to_display" | translate }}</div>
        }
        @for (card of giftCards; track card) {
          <myp-list-item
            [title]="card.code"
            [metadata]="card.metadata"
            [showImage]="true"
            photo="https://cdn.shopify.com/s/files/1/0862/0608/7463/files/GiftCard-FenderOriginal.png?v=1747942094"
            [includeChevron]="false"
            [imageRound]="false"
            [largeImage]="true"
          ></myp-list-item>
        }
        <hr class="m-y-50" />
        <a class="btn btn-primary" (click)="appService.goToFenderShop('products/fender-digital-gift-card', true)">{{ "orders.buy_gift_card" | translate }}</a>
      </div>
    }
    @if (displayedSection == "recurring") {
      <div class="container">
        <fui-heading [text]="'orders.recurring_payments' | translate" [level]="5"></fui-heading>
        @if (!recurringPayments?.length) {
          <div class="m-y-20 text-muted">{{ "orders.no_recurring_payments_to_display" | translate }}</div>
        }
        @if (!loading && recurringPayments?.length) {
          <myp-user-order-list [orders]="recurringPayments"></myp-user-order-list>
        }
        @if (loading) {
          <myp-inline-loader [loading]="true" height="200px" spinnerName="loader"></myp-inline-loader>
        }
      </div>
    }
  </section>
</div>
